import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex items-center gap-2"><img src="/brand/procdeal-logo.png" alt="ProcDeal" className="h-8 w-auto" /></Link>
        <div className="rounded-xl border bg-card p-8">
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Forgot your password?</h1>
          <p className="mt-1 text-sm text-muted-foreground">Enter your work email and we'll help you reset your password.</p>
          {done ? (
            <div data-testid="forgot-success" className="mt-6 rounded-md border border-amber-200 bg-amber-50 px-4 py-3">
              <p className="flex items-center gap-2 text-sm font-semibold text-amber-900"><MailCheck className="h-4 w-4 shrink-0" /> Reset link generated</p>
              <p className="mt-1.5 text-sm text-amber-800">If an account exists for this email, a reset link has been logged. The email service is in mock mode — no real email was sent. Contact your admin to retrieve the link.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="fp-email">Work Email</Label>
                <Input id="fp-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="mt-1.5" />
              </div>
              {error && <p data-testid="forgot-error" role="alert" className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">{error}</p>}
              <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full bg-slate-900 hover:bg-slate-800">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send Reset Link
              </Button>
            </form>
          )}
          <Link to="/login" data-testid="back-to-signin" className="mt-6 flex items-center justify-center gap-1.5 text-sm font-medium text-blue-700 hover:underline">
            <ArrowLeft className="h-4 w-4" /> Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}
